import { render, staticRenderFns } from "./AdRankScatterChart.vue?vue&type=template&id=d20bf4d4&scoped=true"
import script from "./AdRankScatterChart.vue?vue&type=script&lang=js"
export * from "./AdRankScatterChart.vue?vue&type=script&lang=js"
import style0 from "./AdRankScatterChart.vue?vue&type=style&index=0&id=d20bf4d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20bf4d4",
  null
  
)

export default component.exports